import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import history from 'utils/history';
import {
  LOAD_CONFIRMPROFILE,
  CHANGE_CONFIRMPROFILE,
  DELETE_CONFIRMPROFILE,
} from './constants';

import {
  loadConfirmProfileError,
  loadConfirmProfileSuccess,
  changeConfirmProfileError,
  changeConfirmProfileSuccess,
  deleteConfirmProfileSuccess,
  deleteConfirmProfileError,
} from './actions';

import {
  selectConfirmProfileDomain,
  selectConfirmProfileData,
} from './selectors';

import { Button, notification, Divider, Space } from 'antd';

export function* loadConfirmProfile() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );

    // we get the campaigns linked to the confirmProfile
    const confirmProfileList = yield requestWrapper(
      'GET',
      `confirmProfile/`,
      '',
      currentUser?.token,
    );

    if (!confirmProfileList) {
      yield put(loadConfirmProfileSuccess(false));
    } else {
      yield put(loadConfirmProfileSuccess(confirmProfileList));
    }
  } catch (error) {
    yield put(loadConfirmProfileError(error));
  }
}

export function* changeConfirmProfile(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );

    //const confirmProfileData = yield select(selectConfirmProfileData());
    const { confirmProfileData } = action;

    let changedConfirmProfile = false,
      isNew = !confirmProfileData.hasOwnProperty('_id');

    if (confirmProfileData._id === undefined) {
      changedConfirmProfile = yield requestWrapper(
        'POST',
        'confirmProfile/new/',
        confirmProfileData,
      );
      notification.success({ message: 'Created' });
    } else {
      changedConfirmProfile = yield requestWrapper(
        'PATCH',
        'confirmProfile/',
        confirmProfileData,
      );
      notification.success({ message: 'Updated' });
    }

    if (!changedConfirmProfile) {
      yield put(changeConfirmProfileSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        //history.push({ pathname: `/confirmProfile/`+confirmProfileData._id });
      }
      yield put(changeConfirmProfileSuccess(changedConfirmProfile));
    }
  } catch (error) {
    yield put(changeConfirmProfileError(error));
  }
}

export function* deleteConfirmProfile(action) {
  try {
    // we retrieve the token from the local storage
    const token = localStorage.getItem('token');
    const { id } = action;

    const deleteConfirmProfile = yield requestWrapper(
      'PATCH',
      `confirmProfile/remove`,
      {
        _id: id,
        active: false,
      },
      token,
    );

    if (deleteConfirmProfile) {
      yield put(deleteConfirmProfileSuccess());
    }
  } catch (error) {
    yield put(deleteConfirmProfileError(error));
  }
}

export default function* confirmProfileSaga() {
  yield takeLatest(LOAD_CONFIRMPROFILE, loadConfirmProfile);
  yield takeLatest(CHANGE_CONFIRMPROFILE, changeConfirmProfile);
  yield takeLatest(DELETE_CONFIRMPROFILE, deleteConfirmProfile);
}
